"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDetailsToJSON = exports.PaymentDetailsFromJSONTyped = exports.PaymentDetailsFromJSON = exports.instanceOfPaymentDetails = void 0;
var runtime_1 = require("../runtime");
var PaymentType_1 = require("./PaymentType");
/**
 * Check if a given object implements the PaymentDetails interface.
 */
function instanceOfPaymentDetails(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPaymentDetails = instanceOfPaymentDetails;
function PaymentDetailsFromJSON(json) {
    return PaymentDetailsFromJSONTyped(json, false);
}
exports.PaymentDetailsFromJSON = PaymentDetailsFromJSON;
function PaymentDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentType': !(0, runtime_1.exists)(json, 'payment_type') ? undefined : (0, PaymentType_1.PaymentTypeFromJSON)(json['payment_type']),
        'network': !(0, runtime_1.exists)(json, 'network') ? undefined : json['network'],
        'details': !(0, runtime_1.exists)(json, 'details') ? undefined : json['details'],
    };
}
exports.PaymentDetailsFromJSONTyped = PaymentDetailsFromJSONTyped;
function PaymentDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'payment_type': (0, PaymentType_1.PaymentTypeToJSON)(value.paymentType),
        'network': value.network,
        'details': value.details,
    };
}
exports.PaymentDetailsToJSON = PaymentDetailsToJSON;
